import { Serialize } from 'aautil'

export class Category {

  constructor(c){
    this.id = c.id
    this.name = c.name
  }

  @Serialize()
  id: number

  @Serialize()
  name: string

  @Serialize()
  color?: string

  @Serialize()
  icon?: string

  @Serialize()
  children?: Category[]

  matchedCounter?: number

  childmatched?: boolean
  
  type: string
}